import {TCommonModel} from '../common/t-common-model';
import {AutoMap} from '@automapper/classes';
import {FormField} from '../../../core/decorators/form-field.decorator';
import {Validators} from '@angular/forms';

export class GetVerificationCodeRequestModel extends TCommonModel {
  @FormField({
    default: '',
    validators: [Validators.required, Validators.email]
  })
  @AutoMap()
  email!: string;
}

export class GetVerificationCodeResponseModel {

}
